import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsRemove = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M5 13v-2h14v2z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsRemove);
const Memo = memo(ForwardRef);
export default Memo;
